import { render } from "./PercentageSingleValue.vue?vue&type=template&id=2c4d20ff&scoped=true"
import script from "./PercentageSingleValue.vue?vue&type=script&lang=js"
export * from "./PercentageSingleValue.vue?vue&type=script&lang=js"

import "./PercentageSingleValue.vue?vue&type=style&index=0&id=2c4d20ff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/customer-interface-v3/customer-interface-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4d20ff"]])

export default __exports__